import React from 'react';

import { csrfToken } from './providers';

interface Props {
  route: string;
  formRef?: React.Ref<HTMLFormElement>;
  children: React.ReactNode;
}

// Constant Contact uses a server-side OAuth redirect, so this must be a real full-page form
// submission rather than an XHR through helpers/api. The caller supplies the buttons as children.
export function ConstantContactForm({ route, formRef, children }: Props) {
  return (
    <form action={route} method="post" ref={formRef}>
      <input name="authenticity_token" type="hidden" value={csrfToken()} />
      <input name="email_credential[provider]" type="hidden" value="Constant Contact" />
      {children}
    </form>
  );
}
